import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiObjectFormattedOptions} from '../../interfaces/api-object-formatted';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  emptyOptions: ApiObjectFormattedOptions = {
    headers: {},
    params: {},
  };

  constructor(private http: HttpClient) {}

  setOptions(defOptions: ApiObjectFormattedOptions = this.emptyOptions) {
    const settedOptions = {...this.emptyOptions, ...defOptions};
    const params = settedOptions.params;
    const observe = settedOptions.observe ? (settedOptions.observe as 'body') : 'body';

    return {
      headers: new HttpHeaders(settedOptions?.headers),
      params,
      observe,
    };
  }

  get(url: string, defOptions?: ApiObjectFormattedOptions): Observable<any> {
    const options = this.setOptions(defOptions);

    return this.http.get(url, options);
  }

  post(url: string, body: any, defOptions?: ApiObjectFormattedOptions): Observable<any> {
    const options = this.setOptions(defOptions);
    return this.http.post(url, body, options);
  }

  put(url: string, body: any, defOptions?: ApiObjectFormattedOptions) {
    const options = this.setOptions(defOptions);
    return this.http.put(url, body, options);
  }
}
